import Pikaday from "pikaday";
import DateFormat from "../utilities/date-format";


export default class DatePicker {

	#checkInDisplay;
	#checkInSubmit;
	#checkOutDisplay;
	#checkOutSubmit;
	#datePicker;
	#checkIn;
	#checkOut;

	/**
	 *
	 * @param {HTMLInputElement} checkInDisplay
	 * @param {HTMLInputElement} checkOutDisplay
	 */
	constructor(checkInDisplay, checkOutDisplay) {
		this.#checkInDisplay = checkInDisplay;
		this.#checkInSubmit = document.getElementById(checkInDisplay.dataset.submit);
		this.#checkOutDisplay = checkOutDisplay;
		this.#checkOutSubmit = document.getElementById(checkOutDisplay.dataset.submit);

		let keepOpen = false;
		this.#datePicker = new Pikaday({
			blurFieldOnSelect: false,
			field: this.#checkInDisplay,
			firstDay: 1,
			minDate: new Date(),
			position: 'bottom',
			onSelect: (date) => {
				this.#setDate(date);
				keepOpen = !this.#checkOut;
			},
			onOpen: function () {
				const left = parseInt(this.el.style.left);
				if (!isNaN(left) && left < 0) {
					this.el.style.left = '0';
				}
			},
			onClose: () => {
				if (keepOpen) {
					this.#datePicker.show();
				}
				keepOpen = false;
			}
		});

		this.#datePicker.setDate(new Date());
		this.#datePicker.setDate(DateFormat.addDays(new Date(), 2));

		this.#checkOutDisplay.addEventListener('click', () => {
			this.#datePicker.show();
		});
	}


	/**
	 * @param {Date} date
	 */
	#setDate(date) {
		if (!this.#checkIn) {
			this.#checkIn = date;
		} else if (!this.#checkOut) {
			this.#checkOut = date;
			if (this.#checkIn > this.#checkOut) {
				this.#checkOut = this.#checkIn;
				this.#checkIn = date;
			}
		} else {
			this.#checkIn = date;
			this.#checkOut = null;
		}
		this.#datePicker.setStartRange(this.#checkIn);
		this.#datePicker.setEndRange(this.#checkOut);
		this.#datePicker.draw();

		this.#checkInDisplay.value = this.#checkIn ? DateFormat.format(this.#checkIn, DateFormat.DOTS) : '';
		this.#checkInSubmit.value = this.#checkIn ? DateFormat.format(this.#checkIn, DateFormat.ISO_8601) : '';

		this.#checkOutDisplay.value = this.#checkOut ? DateFormat.format(this.#checkOut, DateFormat.DOTS) : '';
		this.#checkOutSubmit.value = this.#checkOut ? DateFormat.format(this.#checkOut, DateFormat.ISO_8601) : '';
	}
}
